import { render } from "./dashboard_page.vue?vue&type=template&id=d672707c&scoped=true"
import script from "./dashboard_page.vue?vue&type=script&lang=js"
export * from "./dashboard_page.vue?vue&type=script&lang=js"

import "./dashboard_page.vue?vue&type=style&index=0&id=d672707c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d672707c"]])

export default __exports__